import React from "react";
import styles from "./FolderItem.module.scss";
import { IObject } from "../../../../../../../redux/reducers/ui/uiTypes";
import { useAppDispatch } from "../../../../../../../redux/store";
import { setActiveFolder } from "../../../../../../../redux/reducers/ui/uiReducer";
import FolderImg from "../../../../../../../assets/images/Folder.png";

interface PropsI {
  folder: IObject;
}
export const FolderItem: React.FC<PropsI> = (props) => {
  const { folder } = props;
  const dispatch = useAppDispatch();

  const handleFolderClick = (folder: IObject) => {
    dispatch(setActiveFolder(folder));
  };

  return (
    <div
      className={styles.item_folder}
      onClick={() => handleFolderClick(folder)}
    >
      <div className={styles.image_wrapper}>
        <img className={styles.folder_back} src={FolderImg} alt="folder img" />

        {!!folder.image && (
          <img
            className={styles.image_product}
            src={folder.image}
            alt="product img"
          />
        )}
      </div>
      <p className={styles.title}>{folder.name}</p>
    </div>
  );
};
